import { defineMessages } from 'react-intl';

export const forceUpdateMessages = defineMessages({
  modalTitle: {
    defaultMessage: 'Install the latest version to continue using Heidi',
    id: '14ZZ36khRd',
    description: 'Heading for the forced update modal',
  },
  modalMessage: {
    defaultMessage:
      'Your Heidi desktop app is out of date. Install and relaunch, or request an update from your admin.',
    id: '1oq39EtaXM',
    description: 'Body copy explaining that the desktop app must be updated',
  },
  bannerMessage: {
    defaultMessage:
      'A new version of Heidi is available. Please update to continue using.',
    id: '4NnVR+lnT3',
    description: 'Grace-period banner when no update deadline is available',
  },
  bannerMessageWithDeadline: {
    defaultMessage:
      'A new version of Heidi is available. Please update before {deadline} to continue using.',
    id: '78LL/wxUI1',
    description: 'Grace-period banner with a deadline to update the desktop app',
  },
  installAndRelaunch: {
    defaultMessage: 'Install & relaunch',
    id: 'tinKaxQMuc',
    description: 'Primary action to install the update and restart the app',
  },
});
